import { defineMessages } from 'react-intl';

const messages = defineMessages({
  thankyouModera: {
    id: 'ZmXqA/',
    defaultMessage: 'between 150% and 195%',
  },
  cta_ROI: {
    id: 'Kvfc5f',
    defaultMessage: 'Calculate ROI',
  },
  returnToEstimator: {
    id: '1fHL/5',
    defaultMessage: 'Return to ROI estimator',
  },
  thankyouNDepartmetn: {
    id: 'EJd62j',
    defaultMessage: 'Number of departments: ',
  },
  graph_title: {
    id: 'UGAtFd',
    defaultMessage: 'ROI over 5 years',
  },
  widget_subtitle: {
    id: 'Z7NvkF',
    defaultMessage:
      'See the potential ROI when you switch to IBM Planning Analytics.',
  },
  thankYouAnnual: {
    id: 'M1jRDR',
    defaultMessage: 'Annual spend on planing  software and maintenace:',
  },
  estimatedRoi: {
    id: 'fo9nRX',
    defaultMessage: 'Estimated ROI: ',
  },
  widget_Title: {
    id: 'a1By9A',
    defaultMessage: 'ROI calculator ',
  },
  thankYouTitle: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  thankYouDetailsTitle: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  thankyouNParticipants: {
    id: 'uj0wkV',
    defaultMessage: 'Number of participants: ',
  },
  footnotes_title: {
    id: 'QXiQEv',
    defaultMessage: 'Disclaimer',
  },
  thankYouSubTitle: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  bottom_text: {
    id: '8ZVfG8',
    defaultMessage: '100%',
  },
  thankyouSimple: {
    id: '7DzkYo',
    defaultMessage: 'between 202% and 257%',
  },
  thankyouComplex: {
    id: 'WkTyL5',
    defaultMessage: 'between 176% and 277%',
  },
  footnotes_paragraph: {
    id: 'zBXzTk',
    defaultMessage:
      'The results shown are based on certain assumptions, including targeted customer profiles, customer sizing activities and realized return per use case; results are based on US data. The results of this tool are provided for illustrative purposes only, to help you determine whether to consider IBM Planning Analytics as a business solution. The results are not based on actual data or statistical modeling, and may not be accurate or applicable to you. Actual results will vary based on your particular business conditions, usage and configurations and environment, among other factors. Results from the calculator should not be relied upon, and are not a guarantee or commitment regarding any potential or actual financial results or other benefits you may achieve. Actual ROI & benefit will vary depending on individual client configurations and conditions.',
  },
  annual_spend: {
    id: 'm0paYn',
    defaultMessage:
      'Enter your current annual spend (US$ K) on planning software and maintenance.',
  },
  cta_contact: {
    id: 'W0Tn8Y',
    defaultMessage: 'Contact sales',
  },
  top_text: {
    id: 'RzcXh4',
    defaultMessage: '300%',
  },
  number_department: {
    id: '8sz7Y0',
    defaultMessage:
      'Enter the number of departments in your organization using planning software.',
  },
  number_participants: {
    id: '5zucMA',
    defaultMessage:
      "Enter the number of participants in your organization's planning and analysis activities.",
  },
});

export default messages;
